module.exports = __webpack_public_path__ + "img/ga-v4.141093cf.jpeg";